import { BaseModel } from "@/store/feathers/feathers.client.js";
import uid from 'quasar/src/utils/uid.js';
const generate = require('project-name-generator');

export default class FormTemplates extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "FormTemplates";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      is_test: false,
      name: generate().dashed,
      description: null,
      type: null,
      kind: null,
      origin: null,
      template: {
        id: uid(),
        header_image_url: null,
        page: {
          backgroundColor: '#ffffff',
          backgroundImage: null,
        },
        container: {
          elevated: true,
          backgroundColor: '#ffffff',
          color: '#333333',
          sideBackgroundColor: '#333333',
          sideColor: '#ffffff',
          columns: 1,
          padding: 20,
        },

        textfield: {
          borderless: false,
          outlined: true,
          filled: false,
          standout: false,
          dense: true,
          stack_label: false,
          square: false,
          rounded: false
        },

        // cardCss: {
        // backgroundColorLight: '#fafafa',
        // colorLight: '#333333',
        // backgroundColorDark: '#333333',
        // colorDark: '#fafafa',
        // borderColorLight: "#c9c9c9",
        // borderColorDark: "#fafafa",
        // borderStyle: "solid",
        // borderWidth: "1px",
        // borderRadius: "4px",
        // padding: "10px",
        // paddingTop: "10px",
        // paddingRight: "10px",
        // paddingBottom: "10px",
        // paddingLeft: "10px",
        // },

        // button: {
        //   is_enabled: true,
        //   title: "Click Me",
        //   font_size: "16px",
        //   padding_top: "5px",
        //   padding_right: "30px",
        //   padding_bottom: "5px",
        //   padding_left: "30px",
        //   backgroundColorLight: "#fafafa",
        //   colorLight: "#333333",
        //   backgroundColorDark: "#000000",
        //   colorDark: "#ffffff",
        //   borderColorLight: "#c4c4c4",
        //   borderColorDark: "#c4c4c4",
        //   borderStyle: "solid",
        //   borderWidth: "1px",
        //   borderRadius: "4px",
        //   outline: false,
        //   ripple: false,
        //   flat: false,
        //   unelevated: true,
        //   glossy: false,
        //   save_token: false,
        // },
        // shipping: {
        //   forms_enabled: false,
        //   fields_enabled: false,
        //   group_label: "Shipping Details",
        //   shipping_contact: false,
        //   shipping_street_1: true,
        //   shipping_street_2: false,
        //   shipping_street_3: false,
        //   shipping_city: true,
        //   shipping_state_code: true,
        //   shipping_postal_code: true,
        //   shipping_country_code: false,
        //   shipping_country_region: true,
        //   shipping_phone: false,
        //   shipping_phone_extension: false,
        //   shipping_whitelist: [],
        // },
        // customer: {
        //   // update setup instanse also
        //   forms_enabled: false,
        //   fields_enabled: false,
        //   group_label: "Customer Details",
        //   customer_company_name: false,
        //   customer_first_name: false,
        //   customer_last_name: false,
        //   customer_display_name: true,
        //   customer_email: true,
        //   customer_phone: false,
        //   customer_phone_extension: false,
        //   customer_select_card_token: false,
        //   customer_select_ach_token: false,
        //   customer_select_company: false, 

        // },
        // contact: {
        //   // update setup instanse also
        //   forms_enabled: false,
        //   fields_enabled: false,
        //   group_label: "Contact Details",
        //   contact_first_name: false,
        //   contact_last_name: false,
        //   contact_display_name: false,
        //   contact_email: false,
        //   contact_phone: false,
        //   contact_phone_extension: false,
        //   contact_select_card_token: false,
        //   contact_select_ach_token: false,
        //   contact_select_company: false,    // admin only single select          
        // },
        // company: {
        //   forms_enabled: false,
        //   fields_enabled: false,
        //   group_label: "Company Details",
        //   company_dba_name: false,
        //   company_legal_name: false,
        //   company_email: false,
        //   company_phone: false,
        //   company_phone_extension: false,
        //   company_select_card_token: false,
        //   company_select_ach_token: false,  
        //   company_select_contact: false,   // <-- admin only multi select  
        // },
        // card: {
        //     is_enabled: false,
        //     is_standard: true,
        //     is_compact: false,
        //     card_label: "Credit Card Details",
        //     customer_label: "Customer Details",
        //     save_token: false,

        //     enable_oneline: false,
        //     enable_number: false,
        //     enable_expiration: false,
        //     enable_cvv: false,
        //     enable_postal_code: false,

        //     enable_month: false,
        //     enable_year: false,

        //     enable_cardholder: false,
        //     require_cardholder: false,

        //     enable_billing: false,
        //     require_billing: false,

        //     enable_customer_name: false,
        //     require_customer_name: false,

        //     enable_customer_email: false,
        //     require_customer_email: false,
        //     enable_customer_phone: false,
        //     require_customer_phone: false,

        //   // forms_enabled: false,
        //   // fields_enabled: false,
        //   // group_label: "Credit Card Details",
        //   // enable_billing: false,
        //   // credit_card_oneline: true,
        //   // credit_card_holder: true,
        //   // credit_card_number: false,
        //   // credit_card_cvv: false,
        //   // credit_card_expiration: false,
        //   // credit_card_month: false,
        //   // credit_card_year: false,
        //   // credit_card_zip: false,
        //   // credit_card_street_1: false,
        //   // credit_card_street_2: false,
        //   // credit_card_city: false,
        //   // credit_card_state_code: false,
        //   // credit_card_state: false,
        //   // credit_card_nickname: false,
        //   // credit_card_country_code: false,
        //   // credit_card_save_token: false,
        // },
        // ach: {
        //   is_enabled: false
        //   // forms_enabled: false,
        //   // fields_enabled: false,
        //   // group_label: "ACH Payment Detail",
        //   // enable_bank: false,
        //   // ach_routing: true,
        //   // ach_account: true,
        //   // ach_owner: true,
        //   // ach_kind: true,
        //   // ach_type: true,
        //   // ach_nickname: false,
        //   // ach_save_token: false,
        // },
        // pii: {
        //   forms_enabled: false,
        //   fields_enabled: false,
        //   group_label: "Personal Details",
        //   pii_ssn: false,
        //   pii_dln: false,
        //   pii_signature: false,
        //   pii_save_token: false,
        // }
      },


      options: {
        amount_due_label: 'AMOUNT DUE',
        memo: null,
        show_form_reference: true,
        items: {
          show_list: false,
          show_amount: true,
          product_links: true,
        },
        taxes: {
          show_list: false,
          show_amount: true,
        },
        fees: {
          show_list: false,
          show_amount: true,
        },
        discounts: {
          show_amount: true,
          show_list: false,
        },
        shipping: {
          show_amount: true,
          show_list: false,
        },
        payment: {
          enable_receipts: true,
          bcc_email: [],
          allow_partial: true,
          approved_url: null,
          declined_url: null,
          error_url: null,
          enable_vault: false,
          require_phone: false,
          terms: [
            {
              days: 0,
              description: 'Due on Receipt'
            }
          ],
          credit_card: {
            is_enabled: true,
            require_billing_address: true,
            add_terms: true,
          },
          ach: {
            is_enabled: true,
            require_bank_info: false,
            add_terms: true,
          }
        },
      },

      brand: {
        is_enabled: true,
        logo_url: null,
        logo_width: 150,
        position: "top",
        align: "center",
        column: 1,
        name: null,
        line_1: null,
        line_2: null,
        phone: null,
        email: null,
        website: null
      },

      policies: [],

      shipping_options: [],

      amounts: {
        enabled: false,
        description: null,
        total: 0,
        subtotal: 0,
        tax: 0,
        fee: 0,
        discount: 0,
        other: 0,
        shipping: 0,
        taxes: [
          // {
          //   is_rate: true,
          //   name: null,
          //   description: null,
          //   amount: 0,
          //   rate: 0,
          // }
        ],
        discounts: [
          // {
          //   is_rate: true,
          //   name: null,
          //   description: null,
          //   amount: 0,
          //   rate: 0,
          // }
        ],
        fees: [
          // {
          //   is_rate: true,
          //   name: null,
          //   description: null,
          //   amount: 0,
          //   rate: 0,
          // }
        ],
        others: [
          // {
          //   is_rate: true,
          //   name: null,
          //   description: null,
          //   amount: 0,
          //   rate: 0,
          // }
        ],
      },

      meta_data: {},
      custom_fields: [],
      is_inactive: false,
      tags: [],
      receipt_template_id: null,
      cart_id: null,
      contact_id: null,
      company_id: null,
      settings_id: null,
      mid_id: null,

      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    }
  }

  // amounts: {
  //   total: 0,
  //   subtotal: 0,
  //   subtotal_description: null,
  //   taxes: 0,
  //   taxes_description: null,
  //   tax_rate: true,
  //   fees: 0,
  //   fees_description: null,
  //   fee_rate: true,
  //   discounts: 0,
  //   discounts_description: null,
  //   discount_rate: true,
  //   shipping: 0,
  //   shipping_description: null,
  // },

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {

    if (data.template && !data.template.contact) {
      data.template.contact = {
        forms_enabled: false,
        fields_enabled: false,
        group_label: "Contact Details",
        contact_first_name: false,
        contact_last_name: false,
        contact_display_name: false,
        contact_email: false,
        contact_phone: false,
        contact_phone_extension: false,
        contact_select_card_token: false,
        contact_select_ach_token: false,
        contact_select_company: false,    // admin only single select          
      }
    }

    if (data.template && !data.template.company) {
      data.template.company = {
        forms_enabled: false,
        fields_enabled: false,
        group_label: "Company Details",
        company_dba_name: false,
        company_legal_name: false,
        company_email: false,
        company_phone: false,
        company_phone_extension: false,
        company_select_card_token: false,
        company_select_ach_token: false,
        company_select_contact: false,   // <-- admin only multi select  
      }
    }





    if (data.contact) {
      data.contact = new models.api.Contacts(data.contact);
    }

    if (data.company) {
      data.company = new models.api.Companies(data.company);
    }

    if (data.mid) {
      data.mid = new models.api.Mids(data.mid);
    }

    if (data.cart) {
      data.cart = new models.api.Carts(data.cart);
    }

    if (data.settings) {
      data.settings = new models.api.CartSettings(data.settings);
    }

    if (data.receipt_template) {
      data.receipt_template = new models.api.ReceiptTemplates(data.receipt_template);
    }

    if (data.forms) {
      data.forms.map(async (form) => {
        form = new models.api.Forms(form);
      });
    }




    return data;
  }
}
